import React, { useContext, useEffect, useState } from 'react';
import { Projeto, updateAcronimoProjeto } from '@app/api/projeto';
import { Widget, FormSelect, FormInput, CrudContext, FormSubmitButton, FormatText, Col, Row } from '@digital/ui';
import { SelectValue } from 'antd/lib/select';
import { AcronimoProjeto } from '@app/api/acronimosProjeto';
import { hasPermission } from '@app/helpers/permissions';
import { TipoOptions } from '@app/api/api';
import { getAllDisciplicaProjetos } from '@app/api/disciplicaProjetos';

interface FormAcronimoProjetoProps {
  selectedItem: Projeto;
  acronimos: AcronimoProjeto[];
  projetoDisciplina: TipoOptions[];
}

const FormAcronimoProjeto = (props: FormAcronimoProjetoProps) => {
  const { acronimos, selectedItem, projetoDisciplina } = props;
  const [acronimoSelecionado, setAcronimoSelecionado] = useState<AcronimoProjeto>();

  
  useEffect(() => {
    const getAcronimoInfo = () => {
      const data = acronimos.find(a => a.id === selectedItem.acronimoProjetoId);
      if (data) setAcronimoSelecionado(data);
    };
    if (selectedItem && selectedItem.acronimoProjetoId) {
      getAcronimoInfo();
    }
  }, [selectedItem, acronimos, projetoDisciplina]);

  const handleUpdate = () => {
    if (selectedItem) {
      updateAcronimoProjeto(selectedItem);
    }
  };


  const handleChangeStatus = (value: SelectValue) => {
    if (value) {
      selectedItem.acronimoProjetoId = String(value);
      const data = acronimos.find(a => a.id === value);
      if (data) setAcronimoSelecionado(data);
    }
  };

  const handleChangeProjetoDisciplina = (value: SelectValue) => {
    if (value) {
      selectedItem.projetoDisciplinaId = String(value);
    }
  };

  return (
    <Widget
      title="Acrônimos"
      actions={[
        hasPermission(['PROJETO_ABA_GERAL_EDITAR']) && (
          <FormSubmitButton type="primary" onClick={handleUpdate}>
            <FormatText id="ui.commons.save" uppercase />
          </FormSubmitButton>
        ),
      ]}>
      <FormSelect
        label="Acrônimo"
        name="acronimoProjetoId"
        options={acronimos && acronimos.map(a => ({ text: a.sigla, value: a.id.toString() }))}
        span={3}
        optionFilterProp="children"
        onChange={value => handleChangeStatus(value)}
      />
      <FormInput
        label="Categoria"
        name="categoria"
        span={3}
        value={acronimoSelecionado && acronimoSelecionado.nomeCategoria}
        disabled
      />
      <FormInput
        label="Grupo"
        name="grupo"
        span={3}
        value={acronimoSelecionado && acronimoSelecionado.nomeGrupo}
        disabled
      />
      {/* <FormInput
        label="Disciplina"
        name="subGrupo"
        span={3}
        value={acronimoSelecionado && acronimoSelecionado.nomeSubGrupo}
        disabled
      /> */}
      <FormSelect
        label="Disciplina"
        name="projetoDisciplinaId"
        options={projetoDisciplina ? projetoDisciplina : []}
        span={3}
        optionFilterProp="children"
        onChange={value => handleChangeProjetoDisciplina(value)}
      />
    </Widget>
  );
};

export default FormAcronimoProjeto;
